import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full mb-2 negative-top" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-xs-12 col-sm-3 col-md-3 col-lg-3 text-start" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fs-1 fw-bold" }, "Calendario")
], -1)
const _hoisted_4 = { class: "col-xs-12 col-sm-9 col-md-9 col-lg-9 text-end" }
const _hoisted_5 = { class: "ulButtons" }
const _hoisted_6 = {
  key: 0,
  class: "me-5"
}
const _hoisted_7 = {
  key: 1,
  class: "me-5"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fs-base fw-bold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "isax-setting-2 fs-base fw-normal me-1" }),
  /*#__PURE__*/_createTextVNode("Configurar agenda ")
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "fs-base fw-bold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "isax-setting-2 fs-base me-1" }),
  /*#__PURE__*/_createTextVNode("Configurar agenda ")
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loaderClientVue = _resolveComponent("loaderClientVue")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _component_ModalAgenda = _resolveComponent("ModalAgenda")!
  const _component_ModalCreateSchedule = _resolveComponent("ModalCreateSchedule")!
  const _component_ModalCitaDetalle = _resolveComponent("ModalCitaDetalle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_loaderClientVue, { showLoader: _ctx.loading }, null, 8, ["showLoader"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_ctx.searchPermission('Crear cita'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                  _createVNode(_component_Field, {
                    name: "Tipo",
                    autocomplete: "off",
                    class: "form-select form-select-solid select2-hidden-accessible",
                    modelValue: _ctx.tipoCita,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tipoCita) = $event)),
                    style: {"margin-left":"5px"}
                  }, {
                    default: _withCtx(({ value, errorMessage, handleChange }) => [
                      _createVNode(_component_el_select, {
                        class: "w-100",
                        name: "Tipo",
                        value: value,
                        "model-value": value,
                        "onUpdate:modelValue": handleChange,
                        loading: _ctx.loading,
                        size: "large",
                        onChange: _ctx.getMeetings
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["value", "model-value", "onUpdate:modelValue", "loading", "onChange"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.searchPermission('Configurar agenda de agencia'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    "aria-pressed": "false",
                    class: "btn btn-secondary",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.configAgenda && _ctx.configAgenda(...args)))
                  }, _hoisted_9)
                ]))
              : _createCommentVNode("", true),
            (_ctx.searchPermission('Crear cita'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    title: "Crear Cita",
                    "aria-pressed": "false",
                    class: "btn btn-primary fs-base fw-bold",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createDate && _ctx.createDate(...args)))
                  }, "Crear Cita")
                ]))
              : _createCommentVNode("", true),
            (_ctx.searchPermission('Configurar agenda a domicilio'))
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                  _createElementVNode("button", {
                    type: "button",
                    "aria-pressed": "false",
                    class: "btn btn-primary",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.configDates && _ctx.configDates(...args)))
                  }, _hoisted_13)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        (_ctx.calendarOptions)
          ? (_openBlock(), _createBlock(_component_FullCalendar, {
              key: 0,
              class: "demo-app-calendar",
              options: _ctx.calendarOptions
            }, null, 8, ["options"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.searchPermission('Configurar agenda de agencia'))
      ? (_openBlock(), _createBlock(_component_ModalAgenda, {
          key: 0,
          ref: "ModalConfigSchedules"
        }, null, 512))
      : _createCommentVNode("", true),
    (_ctx.searchPermission('Crear cita'))
      ? (_openBlock(), _createBlock(_component_ModalCreateSchedule, {
          key: 1,
          ref: "ModalCreateSchedules",
          change: _ctx.change,
          onUpdateCalendar: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getMeetings($event)))
        }, null, 8, ["change"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalCitaDetalle, {
      ref: "ModalDetailMeetingRef",
      detailMeeting: _ctx.detailmeeting
    }, null, 8, ["detailMeeting"])
  ], 64))
}